<template>
  <div>
    <div class="parallax"></div>
    <div class="container" id="order">
      <h2> Order</h2>
      <div class="order">
        <div class="infos">
          <input type="text" v-model="name" placeholder="Last name">
          <input type="text" v-model="firstname" placeholder="First name">
          <input type="tel" v-model="phone" placeholder="Phone number">
        </div>
        <input type="email" v-model="email" placeholder="Email">
        <textarea class="textarea"v-model="message" placeholder="Your order"></textarea>
        <a v-if="visibleSendButton" :href="mailto" target="_blank">Order</a>
        <p class="error" v-else>{{error}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      message: '',
      name: '',
      firstname: '',
      phone: '',
      mailto: '',
      visibleSendButton: false,
      error: "Please fill all the fields"
    }
  },
  methods: {
    checkFields() {
      if(this.email !== '' && this.message !== '' && this.phone !== '' && this.name !== '' && this.firstname !== '') {
        var re = /\S+@\S+\.\S+/;
        var ret = /^[\+]?[0-9]{6,}$/im
        if(!re.test(this.email)) {
          this.error = "The email is badly formatted"
          this.visibleSendButton = false
        } else if(!ret.test(this.phone)) {
          this.error = "The phone number is badly formatted"
          this.visibleSendButton = false
        } else {
          this.error = ""
          this.visibleSendButton = true
          this.mailto = "mailto:vetopas@andorra.ad?subject=Commande de "
          + this.name + " " + this.firstname
          + "&body=" + this.message + "%0D%0AContact : "
          + this.email + " " + this.phone
        }
      }
    }
  },
  watch: {
   email() {
     this.checkFields()
   },
   message() {
     this.checkFields()
   },
   phone() {
     this.checkFields()
   },
   name() {
     this.checkFields()
   },
   firstname() {
     this.checkFields()
   }
  }
}
</script>

<style scoped>

.container {
  margin-bottom: 5em;
}
.parallax {
  background-image: url("../../../static/images/bunny-cute-detail-53966.jpg");
}

.order {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  width: 80%;
  margin:auto;
}

input {
  width: 100%;
  padding: 0.2em;
  padding-top: 1em;
  padding-bottom: 1em;
  margin-bottom: 1em;
}

.textarea {
  height: 15em;
  width: 100%;

  padding: 0.2em;
  padding-top: 1em;
  padding-bottom: 1em;
  overflow-x: hidden;
  overflow-y: scroll;
}

.error {
  color: red;
}

.infos input {
  width: 30em;
}

.infos {
  padding: 0.2em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.block {
  max-width: 30vw;
  margin: 2em;
}


.order a {
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// Order.vue?7c3bcd50